import { FC, useContext } from 'react'

import { TpTimestampRangeCtx, TTpTimestampRangeCtx } from '../service/TpTimestampRangeContext'
import { DelayString } from './TpDelayString'
import { Reason } from './TpReason'

interface SingleDelayStringAndReasonCtx {
  showReason: boolean
}

interface SingleDelayStringAndReasonProps {
  colorClass: string
  delayString: string
  initialDate: string
  reason: string
}

interface LeanSingleDelayStringAndReasonProps
  extends SingleDelayStringAndReasonProps,
    Partial<SingleDelayStringAndReasonCtx> {}

// (+5d) reason
export const LeanSingleDelayStringAndReason: FC<LeanSingleDelayStringAndReasonProps> = (props) => {
  const { showReason = true } = props
  return (
    <>
      <DelayString colorClass={props.colorClass} delayString={props.delayString} initialDate={props.initialDate} />
      {showReason && <Reason colorClass={props.colorClass} reason={props.reason} />}
    </>
  )
}

export const SingleDelayStringAndReason: FC<SingleDelayStringAndReasonProps> = (props) => {
  const { showReason }: TTpTimestampRangeCtx = useContext(TpTimestampRangeCtx)
  return <LeanSingleDelayStringAndReason showReason={showReason} {...props} />
}
